import AppRecord from './AppRecord.js'

class PersonConsultant extends AppRecord {
  resetMomerizedComputed(){
    this._person_name = undefined
    this._consultant_name = undefined
  }
  get person(){
    return this.constructor.employeeStore.peopleById.get(this.person_id)
  }
  get consultant(){
    return this.constructor.employeeStore.peopleById.get(this.consultant_id)
  }
  get person_name(){
    if(this._person_name){return this._person_name}
    if(this.person){
      return this._person_name = this.person.name
    } else {
      return undefined
    }
  }
  get consultant_name(){
    if(this._consultant_name){return this._consultant_name}
    if(this.consultant){
      return this._consultant_name = this.consultant.name
    } else {
      return undefined
    }
  }
  get variantType(){
    switch (this.relation_type) {
      case 'primary':
        return 'success'
      case 'secondary':
        return 'danger'
      default:
        return 'warning'
    }
  }
  get translatedType(){
    switch (this.relation_type) {
      case 'primary':
        return 'Primær'
      case 'secondary':
        return 'Sekundær'
      case 'external':
        return 'Ekstern'
    }
    return 'UKENDT'
  }
}

export default PersonConsultant
